import axios from 'axios';

export const refreshToken = async () => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await axios.post('/api/refresh-token', {}, {
            headers: { Authorization: `Bearer ${token}` }
        });
        sessionStorage.setItem('token', response.data.token);
    } catch (error) {
        console.error('Error refreshing token', error);
    }
};